import { FieldValues, Path, UseFormReturn } from "react-hook-form";
import { FormComponent, FormField, FormItemLabel, FormRow } from "../../form";
import { FormInput } from "../../form/fields";

type CompanyNameFeinFieldValues = {
	name?: string | null;
	fein?: string | null;
};

type CompanyNameFeinFieldsProps<TFieldValues extends FieldValues & CompanyNameFeinFieldValues> = {
	// biome-ignore lint/suspicious/noExplicitAny: legacy any
	formMethods: UseFormReturn<TFieldValues, any, any>;
	partialRequiresSubmit?: boolean;
	disabled?: boolean;
};

// Field names are cast to Path<TFieldValues>: the constraint guarantees the fields, but TS can't
// prove a literal is a member of the recursive Path type for an abstract generic.
export const CompanyNameFeinFields = <
	TFieldValues extends FieldValues & CompanyNameFeinFieldValues,
>({
	formMethods,
	partialRequiresSubmit,
	disabled,
}: CompanyNameFeinFieldsProps<TFieldValues>) => (
	<FormRow>
		<FormField className="flex-2" condensed>
			<FormItemLabel condensed required>
				Name
			</FormItemLabel>
			<FormInput
				name={"name" as Path<TFieldValues>}
				control={formMethods.control}
				testId="company-name-input"
				compact
				disabled={disabled}
			/>
		</FormField>
		<FormComponent
			formMethods={formMethods}
			name={"fein" as Path<TFieldValues>}
			label="FEIN"
			inline
			className="max-w-[200px]"
			partialRequiresSubmit={partialRequiresSubmit}
		>
			<FormInput
				name={"fein" as Path<TFieldValues>}
				control={formMethods.control}
				compact
				onlyNumbers
				maxLength={15}
				disabled={disabled}
			/>
		</FormComponent>
	</FormRow>
);
